/* eslint-disable no-console */
/* eslint-disable no-await-in-loop */
// FilesDownloader.tsx
import { Button, Flex, Progress, Text, VStack } from '@chakra-ui/react';
import Papa from 'papaparse';
import React, { useState, useEffect } from 'react';

import type {
  ValleyFile,
  ValleyFileGraph,
} from '@finley-technologies/valley-bank-utils';
import { valleyFiles } from '@finley-technologies/valley-bank-utils';

// Types
type FileDownload = {
  slugKey: ValleyFile;
  slugValue: string;
  download: { url: string } | null;
};
type FileDownloadInternal = FileDownload & {
  status: string;
  data: any[];
};

// Exports
type FilesDownloaderProps = {
  files: FileDownload[];
  onAllFilesDownloaded: (graph: ValleyFileGraph) => void; // Callback when all files are downloaded
};
export const FilesDownloader = ({
  files,
  onAllFilesDownloaded,
}: FilesDownloaderProps) => {
  const [filesStatus, setFilesStatus] = useState<FileDownloadInternal[]>(
    files.map((file) => ({
      ...file,
      status: 'pending', // Initial fetch status
      data: [],
    })),
  );

  useEffect(() => {
    const allDownloaded = filesStatus.every(
      (file) => file.status === 'completed',
    );
    // at this time we want to generate the ValleyFileGraph
    // and return to caller.

    if (allDownloaded) {
      const ingestedFiles = filesStatus.map((file) => ({
        file: file.slugKey,
        data: file.data,
      }));
      const graph = valleyFiles.generateRelationGraph(ingestedFiles);
      onAllFilesDownloaded(graph);
    }
  }, [filesStatus, onAllFilesDownloaded]);

  const fetchData = async () => {
    const updatedFilesStatus = filesStatus.map((file) => ({
      ...file,
      status: 'fetching',
    }));
    setFilesStatus(updatedFilesStatus);

    // eslint-disable-next-line no-restricted-syntax, finley/variable-length, no-plusplus
    for (let i = 0; i < updatedFilesStatus.length; i++) {
      const artifact = updatedFilesStatus[i];
      if (artifact.download) {
        try {
          const response = await fetch(artifact.download.url);
          const text = await response.text();
          const data = Papa.parse(text, { header: true, dynamicTyping: true });
          updatedFilesStatus[i].status = 'completed';
          updatedFilesStatus[i].data = data.data;
        } catch (error) {
          updatedFilesStatus[i].status = 'error';
          console.error(error);
        }
        setFilesStatus([...updatedFilesStatus]);
      }
    }
  };

  const getFileProgress = (status: string): number => {
    switch (status) {
      case 'completed':
        return 100;
      case 'fetching':
        return 50;
      default:
        return 0;
    }
  };

  return (
    <VStack spacing={4}>
      <Button onClick={fetchData}>Fetch data</Button>
      {filesStatus.map((file) => (
        <Flex key={file.slugKey} alignItems="center" width="100%">
          <Text flex="1">{file.slugKey}</Text>
          <Progress flex="2" value={getFileProgress(file.status)} />
          <Text ml="2">{file.status}</Text>
        </Flex>
      ))}
    </VStack>
  );
};
